import { Grid } from '@mui/material';
import styled from 'styled-components';
export const DataViewGrid = styled(Grid) `
  flex: 1;
  //352 = max-width of column included paddings, 2 = border, 16 = right and left spacing of container, 32 = additional padding and border
  max-width: ${(props) => props.columns * 352 + 2 + 16 + (props.hastabpanel === 'true' ? 32 : 0)}px;
  min-width: ${(props) => props.columns * 250}px;
`;
